<template>
	<div grey-back full-height>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">TF > {{toolBarTitle}}</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn>

		    <!-- <v-btn icon @click="fn_getBottomMenu(false)">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar grey-back">

			<v-layout wrap padding-top-bottom-ten white-background>
			  	<v-flex xs12 sm12 md12 form-item>
		           <v-text-field  v-model="Form.name" label="Name" placeholder=" " @input="fn_copyName" v-validate="'required'" :error-messages="errors.collect('name')" data-vv-name="name" required></v-text-field>
		        </v-flex>

		        <v-flex xs12 sm12 md12 form-item>
		           <v-text-field  v-model="Form.title" label="Title" placeholder=" " data-vv-name="title" @input="titleFieldChanged=true"></v-text-field>
		        </v-flex>
			</v-layout>

			<div v-if="typeName=='sale' || typeName=='purchase'">

				<v-layout wrap padding-top-bottom-ten white-background margin-top-ten v-if="showImportExport">

			        <v-layout row wrap form-item id="transactionType_field">
			        	<v-flex xs4 sm4 md4>
				           	<v-checkbox label="Local" v-model="Form.local" @change="fn_updateType('disableIE')"></v-checkbox>
				        </v-flex>

				        <v-flex xs4 sm4 md4>
				           	<v-checkbox label="Central" v-model="Form.central" @change="fn_updateType('disableIE')"></v-checkbox>
				        </v-flex>

				        <v-flex xs4 sm4 md4>
				           	<v-checkbox :label="labels.importExport" v-model="Form.importExport" @change="fn_updateType('disableLC')"></v-checkbox>
				        </v-flex>

				        <div v-if="invalidForm && !Form.local && !Form.central && !Form.importExport">
			            	<span class="error--text font-small" v-if="">Choose transaction type</span>
			            </div>

			        </v-layout>

			        <v-layout row wrap>

			        	<v-layout row wrap v-show="!Form.importExport"><!-- v-show="Form.transactionNature==0" -->
				        	<v-flex xs12 sm12 md12 form-item v-if="Form.local"
				        	@click="fn_openLocalTransactionLedgers('android', 'LocalTransactionLedger', 'field_localTransactionLedger')">

				        		<!-- v-if="Form.transactionNature==0" -->
				               <v-text-field  
					               	readonly 
					               	v-model="Form.localTransactionAccountName" 
					               	:label="labels.localLedger"
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="field_localTransactionLedger"
					               	:onUpdate="fn_updateLocalTransactionLedger"
					               	v-validate="'required'" 
					               	:error-messages="errors.collect('local ledger')" 
					               	:data-vv-as="labels.localLedger"
					               	data-vv-name="local ledger" 
					               	required>
				               </v-text-field>
				            </v-flex>

				            <v-flex xs12 sm12 md12 form-item v-if="Form.central"
				            	@click="fn_openCentralTransactionLedgers('android', 'CentralTransactionLedger', 'field_centralTransactionLedger')">

				            	<!-- v-if="Form.transactionNature==0"  -->
				               <v-text-field 
					               	readonly 
					               	v-model="Form.centralTransactionAccountName" 
					               	:label="labels.centralLedger"
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="field_centralTransactionLedger"
					               	:onUpdate="fn_updateCentralTransactionLedger"
					               	v-validate="'required'" 
					               	:error-messages="errors.collect('central ledger')" 
					               	:data-vv-as="labels.centralLedger" 
					               	data-vv-name="central ledger" 
					               	required>
				               </v-text-field>
				            </v-flex>
				        </v-layout>
				        <!-- v-show="Form.transactionNature==1" -->
			            <v-layout row wrap v-show="Form.importExport">
			             	<v-flex xs12 sm12 md12 form-item v-if="Form.importExport"
				        	@click="fn_openImportExportTransactionLedgers('android', 'ImportExportTransactionLedger', 'field_importExportTransactionLedger')">

				        		<!-- v-if="Form.transactionNature==1" -->
				               <v-text-field  
					               	readonly 
					               	v-model="Form.importExportTransactionAccountName" 
					               	:label="labels.importExportLedger" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="field_importExportTransactionLedger"
					               	:onUpdate="fn_updateImportExportTransactionLedger"
					               	v-validate="'required'" 
					               	:error-messages="errors.collect('salepurchase ledger')"  
					               	data-vv-name="salepurchase ledger" 
					               	:data-vv-as="labels.importExportLedger"
					               	required>
				               </v-text-field>
				            </v-flex>
			            </v-layout>
			        </v-layout>
				</v-layout>

				<v-layout wrap white-background margin-top-ten id="partyGroups_field">
				  <v-flex xs12 sm12 md12 form-item>

		               <v-list-tile nopadding light-opacity-color font14
			            	ref="field_partyGroups" 
			            	:onUpdate="fn_updatePartyGroups"
			            	 @click="fn_openPartyGroups('android', 'PartyGroups', 'field_partyGroups')">
			            	<v-list-tile-content>
			                	<v-list-tile-title>{{labels.partyGroup}}</v-list-tile-title>
			              	</v-list-tile-content>
			              	<v-list-tile-action>
			                	<v-icon>keyboard_arrow_right</v-icon>
			              	</v-list-tile-action>
			            </v-list-tile>
		            </v-flex>

		            <div padding-all-16 v-if="invalidForm && !Form.isAllPartySelected && !Form.transactionParties.length">
		            	<span class="error--text font-small">Choose minimum one {{labels.partyGroup}}</span>
		            </div>

					<div padding-all-16 v-if="Form.isAllPartySelected || Form.transactionParties.length">
						<div v-if="Form.isAllPartySelected">
							<v-chip close outline label @input="fn_removeAllPartyGroups">
								All {{labels.partyGroup}}s
							</v-chip>
						</div>
						
						<div v-else>
							<v-chip close outline label v-for="(item, index) in Form.transactionParties" :key="index" @input="fn_removePartyGroup(index)">{{item.name}}</v-chip>
						</div>
					</div>
				</v-layout>

				<v-layout wrap white-background margin-top-ten v-if="typeName=='sale'">
					<v-subheader full-width border-bottom-thin>Tax</v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.taxMode" row>
					      <v-radio label="None" :value="0" :disabled="Form.importExport"></v-radio>
					      <v-radio label="Exclusive" :value="1" :disabled="$root.CurrentBusiness.GSTRegistrationStatus != 1"></v-radio>
					      <v-radio label="Inclusive" :value="2" :disabled="$root.CurrentBusiness.GSTRegistrationStatus != 1"></v-radio>
					    </v-radio-group>
			        </v-flex>
				</v-layout>

				<v-layout wrap white-background margin-top-ten v-if="typeName=='sale'">
					<v-subheader full-width border-bottom-thin>Trading Type</v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.tradingType" row>
					      <v-radio label="Retail" :value="0"></v-radio>
					      <v-radio label="Whole Sale" :value="1"></v-radio>
					    </v-radio-group>
			        </v-flex>
				</v-layout>

				<!-- <v-layout wrap white-background margin-top-ten v-if="typeName=='sale' && showImportExport"> -->
				<!-- <v-layout wrap white-background margin-top-ten>
					<v-subheader full-width border-bottom-thin>Mode of Payment</v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.paymentMode" row>
					      <v-radio label="Credit" :value="0" ></v-radio>
					      <v-radio label="Cash" :value="1"></v-radio>
					    </v-radio-group>
			        </v-flex>
				</v-layout>		 -->        

				<v-layout wrap white-background margin-top-ten v-if="typeName=='sale' && showInvoiceType">
					<v-subheader full-width border-bottom-thin>Invoice Type<!-- Group --></v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.invoiceType" row>
					      <v-radio label="Tax Invoice" :value="1" ></v-radio>
					      <v-radio label="Bill of Supply" :value="0"></v-radio>	
					    </v-radio-group>
			        </v-flex>
				</v-layout>

				<!-- <v-layout wrap white-background margin-top-ten v-if="typeName=='sale' && showInvoiceGroup">
					<v-subheader full-width border-bottom-thin>Group</v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.salesGroupType" row>
					      <v-radio label="Tax Invoice" :value="1" ></v-radio>
					      <v-radio label="Bill of Supply" :value="0"></v-radio>	
					    </v-radio-group>
			        </v-flex>
				</v-layout> -->

				<v-layout wrap white-background margin-top-ten v-if="showInventory">
					<v-subheader full-width border-bottom-thin>Inventory</v-subheader>
				  	<v-flex xs12 sm12 md12 form-item>
			           	<v-radio-group v-model="Form.inventory" row>
					      <v-radio label="Yes" :value="1"></v-radio>
					      <v-radio label="No" :value="0"></v-radio>
					    </v-radio-group>
			        </v-flex>
				</v-layout>

				<!-- <v-layout row wrap white-background margin-top-ten v-if="showInvoiceType">
		        	<v-subheader full-width border-bottom-thin>Invoice Type</v-subheader>
		        	<v-divider></v-divider>
		          	<v-flex xs12 sm12 md12 form-item>
		               	<v-radio-group v-model="Form.invoiceType" row>
					      <v-radio label="Goods" :value="0"></v-radio>
					      <v-radio label="Service" :value="1"></v-radio>
					    </v-radio-group>
		            </v-flex>
		        </v-layout> -->
			</div>

			<!-- Number Series -->
			<v-layout wrap padding-top-bottom-ten white-background margin-top-ten>
				<v-flex xs12 sm12 md12 form-item @click="fn_openNumberSeriesDialog">
		        	<v-text-field 
		               	readonly 
		               	v-model="Form.numberSeriesName" 
		               	label="Number Series" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	ref="field_numberSeries"
		               	v-validate="'required'" 
		               	:error-messages="errors.collect('Number Series')" 
		               	data-vv-name="Number Series"
		               	required>
	               </v-text-field>
		        </v-flex>
			</v-layout>

			<!-- Print Template -->
			<v-layout wrap padding-top-bottom-ten white-background margin-top-ten>
				<v-flex xs12 sm12 md12 form-item @click="fn_openPrintTemplateDialog">
		        	<v-text-field 
		               	readonly 
		               	v-model="Form.printTemplateName" 
		               	label="Print Template" 
		               	placeholder=" " 
		               	append-icon="arrow_drop_down">
	               </v-text-field>
		        </v-flex>
			</v-layout>

			<div v-if="typeName=='sale' || typeName=='purchase'">

				<v-layout wrap white-background margin-top-ten v-if="typeName=='sale' && $root.TransactionSettings.beatRouteArea">
				  	<v-flex xs12 sm12 md12 form-item>
			        	<v-checkbox right-align-checkbox label="Beat/Area/Route Applicable?" v-model="Form.isRouteApplicable"></v-checkbox>
			        </v-flex>
				</v-layout>

				<v-list two-line nopadding margin-top-ten>
					<v-subheader subheader-dense dark-grey>Product</v-subheader>
					<v-subheader>Discounts/Taxes/Other Charges
						<v-spacer></v-spacer>
						<v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_getBottomMenu('product')">Add</v-btn>
					</v-subheader>
					<v-divider></v-divider>
				  	<div v-for="(item, index) in Form.addOnsProductLevel" :key="index" :id="'item_'+item.transactionTypeAddOnsId">
	        			<v-list-tile>
		        			<v-list-tile-content>
		        				<v-list-tile-title>{{item.name}} ({{item.mode ? '&#8377;' : '%'}})</v-list-tile-title>
		        				<v-list-tile-sub-title v-if="item.mode == 0 && item.percentage != null">
		        					{{item.percentage}}
		        					<!-- {{item.percentage != null ? item.percentage : item.value != null ? item.value : 'Not Filled'}} -->
		        				</v-list-tile-sub-title>

		        				<v-list-tile-sub-title v-if="item.mode == 1 && item.value != null">
		        					{{item.value}}
		        					<!-- {{item.percentage != null ? item.percentage : item.value != null ? item.value : 'Not Filled'}} -->
		        				</v-list-tile-sub-title>
		        			</v-list-tile-content>
		        			<v-list-tile-action>
		        				<v-menu bottom left>

							      <v-btn slot="activator" icon>
							      	<v-icon>more_vert</v-icon>
							      </v-btn>

							      <v-list nopadding>
							      	<v-list-tile @click="fn_openMoveAddOnsDialog(Form.addOnsProductLevel, index)" :disabled="Form.addOnsProductLevel.length==1 || (Form.addOnsProductLevel.length==2 && index==1)">
							          <v-list-tile-title>Move</v-list-tile-title>
							        </v-list-tile>

							        <v-divider></v-divider>

							        <v-list-tile @click="fn_editAddOns(item)">
							          <v-list-tile-title>Edit</v-list-tile-title>
							        </v-list-tile>

							        <v-divider></v-divider>

							        <v-list-tile @click="fn_removeAddOns(item, index)">
							          <v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
							      </v-list>

							    </v-menu>
		        			</v-list-tile-action>
		        		</v-list-tile>
		        		<v-divider v-if="Form.addOnsProductLevel.length-1 != index"></v-divider>
	        		</div>
				</v-list>

				<v-list two-line nopadding margin-top-ten>
					<v-subheader subheader-dense dark-grey>Transaction/Billing</v-subheader>
					<v-subheader>Discounts/Taxes/Other Charges
						<v-spacer></v-spacer>
						<v-btn flat small color="primary" justify-content-to-end nomargin :ripple="false" @click="fn_getBottomMenu('bill')">Add</v-btn>
					</v-subheader>
					<v-divider></v-divider>
				  	<div v-for="(item, index) in Form.addOnsBillLevel" :key="index" :id="'item_'+item.transactionTypeAddOnsId">
	        			<v-list-tile>
		        			<v-list-tile-content>
		        				<v-list-tile-title>{{item.name}} ({{item.mode ? '&#8377;' : '%'}})</v-list-tile-title>
		        				<v-list-tile-sub-title>
		        					{{item.percentage != null ? item.percentage : item.value != null ? item.value : 'Not Filled'}}
		        				</v-list-tile-sub-title>
		        			</v-list-tile-content>
		        			<v-list-tile-action>
		        				<v-menu bottom left>

							      <v-btn slot="activator" icon>
							      	<v-icon>more_vert</v-icon>
							      </v-btn>

							      <v-list nopadding>
							      	<v-list-tile @click="fn_openMoveAddOnsDialog(Form.addOnsBillLevel, index)" :disabled="Form.addOnsBillLevel.length==1 || (Form.addOnsBillLevel.length==2 && index==1)">
							          <v-list-tile-title>Move</v-list-tile-title>
							        </v-list-tile>

							        <v-divider></v-divider>

							        <v-list-tile @click="fn_editAddOns(item)">
							          <v-list-tile-title>Edit</v-list-tile-title>
							        </v-list-tile>

							        <v-divider></v-divider>

							        <v-list-tile @click="fn_removeAddOns(item, index)">
							          <v-list-tile-title>Remove</v-list-tile-title>
							        </v-list-tile>
							      </v-list>

							    </v-menu>
		        			</v-list-tile-action>
		        		</v-list-tile>
		        		<v-divider v-if="Form.addOnsBillLevel.length-1 != index"></v-divider>
	        		</div>
				</v-list>

				<!-- Dynamic Fields -->
				<field-items 
					v-if="$refs['ref_fieldsForm']"	
					ref="ref_fieldItems"
					:fieldItems="Form.fieldItems"
					:openFieldListDialog="$refs['ref_fieldsForm'].fn_openFieldList"
					:openSectionList="$refs['ref_fieldsForm'].fn_openSectionList"
					:openSectionForm="$refs['ref_fieldsForm'].fn_openSectionForm"
					:comingSoon="comingSoon"
					:editField="$refs['ref_fieldsForm'].fn_editField"
					:removeField="$refs['ref_fieldsForm'].fn_removeField"
					:openMoveFieldDialog="$refs['ref_fieldsForm'].fn_openMoveFieldDialog"
					:editSection="$refs['ref_fieldsForm'].fn_editSection"
					:openReorderSectionDialog="$refs['ref_fieldsForm'].fn_openReorderSectionDialog"
					:key="fieldItemsComponentKey">
				</field-items>

			</div>
			

		</v-form>

	    <v-snackbar v-model="snackbar" :timeout="3000">
	    	<div v-html="snackbar_msg"></div>
	    </v-snackbar>

	    <field-form 
	    	ref="ref_fieldsForm">
	  		
	    </field-form>

	    <dialog-field-list 
	    	v-if="$refs['ref_fieldsForm']"
	    	ref="ref_fieldList" 
	    	:setFieldValue="$refs['ref_fieldsForm'].fn_setFieldValue"
	    	:getFieldData="$refs['ref_fieldsForm'].fn_getFieldData">
	    		
	    </dialog-field-list>

	    <dialog-section-list 
	    	v-if="$refs['ref_fieldsForm']" 
	    	ref="ref_sectionList" 
	    	:updateSection="$refs['ref_fieldsForm'].fn_updateSection" 
	    	:openSectionForm="$refs['ref_fieldsForm'].fn_openSectionForm"
	    	:getFieldData="$refs['ref_fieldsForm'].fn_getFieldData">
	    		
	    </dialog-section-list>

	    <dialog-section-form 
	    	v-if="$refs['ref_fieldsForm']" 
	    	ref="ref_sectionForm" 
	    	:updateSectionList="$refs['ref_fieldsForm'].fn_updateSectionList" 
	    	:updateSection="$refs['ref_fieldsForm'].fn_updateSection"
	    	:addSection="$refs['ref_fieldsForm'].fn_addSection"
	    	:sectionList="sectionItemList">
	    		
	    </dialog-section-form>

	    <dialog-move-field 
	    	ref="ref_moveField" 
	    	:moveField="$refs['ref_fieldsForm'].fn_moveField"
	    	:closeMoveFieldDialog="$refs['ref_fieldsForm'].fn_closeMoveFieldDialog" 
	    	v-if="$refs['ref_fieldsForm']">
	    		
	    </dialog-move-field>

	    <dialog-reorder-section
	    	ref="ref_reorderSection"
	    	:fieldItems="Form.fieldItems"
	    	:applyReorder="$refs['ref_fieldsForm'].fn_applyReorder"
	    	v-if="$refs['ref_fieldsForm']">
	    	
	    </dialog-reorder-section>

	    <dialog-number-series 
	    	ref="ref_numberSeries" 
	    	:setNumberSeries="fn_setNumberSeries"
	    	:getFormData="fn_getFormData">
	    		
	    </dialog-number-series>

	    <dialog-print-template 
	    	ref="ref_printTemplate" 
	    	:setPrintTemplate="fn_setPrintTemplate"
	    	:getFormData="fn_getFormData"
	    	:removePrintTemplate="fn_removePrintTemplate">
	    		
	    </dialog-print-template>

	    <dialog-addons 
	    	ref="ref_dialogAddOns" 
	    	:openAddOnsList="fn_openAddOnsList" 
	    	:addOnsProp="Form.addOnsProp" 
	    	:saveAddOns="fn_saveAddOns">
	    		
	    </dialog-addons>

	    <dialog-move-addons 
	    	ref="ref_dialogMoveAddOns"
	    	:addOnsMovableItems="addOnsMovableItems"
	    	:moveAddOns="fn_moveAddOns">
	    </dialog-move-addons>

	    <dialog-loading 
	    	ref="ref_dialogLoading"
	    	:loading="isLoading">
	    </dialog-loading>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	</div>
</template>

<script>

const dialogjs =  require('../../masters/forms/dialog').dialogjs;
const menuItem = require('../../../config.js').configs.menuItem;
const transactionForms = require('../../../config.js').configs.transactionForms;
const transactionTypes = require('../../../config.js').configs.transactionTypes;
const accountGroupIds = require('../../../config.js').configs.accountGroupIds;

import fieldForm from '../../fields/dialog_field_form';
import sectionForm from '../../fields/dialog_section_form';
import fieldList from '../../fields/dialog_field_list';
import sectionList from '../../fields/dialog_section_list';
import moveFieldDialog from '../../fields/dialog_move_field';

import reorderSectionDialog from '../../fields/reorder_section';
import fields from '../../fields/fields';

import numberSeriesDialog from '../../number_series/dialog_number_series';
import printTemplateDialog from '../../print_templates/dialogs/dialog_print_template';

import dialogAddOns from '../../dialogs/dialog_addons'
import dialogMoveAddOns from './dialog_move_addons'

import dialogLoading from '../../dialogs/dialog_loading'

import dialogDiscard from '../../dialogs/dialog_discard'
import {draftMixin} from '../../draft_mixin'


	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"fieldData":JSON.parse(JSON.stringify(require('../../fields/datamodel.js').data.fieldData)),

					"name":null,
					"title":null,
					"transactionTypeId":null,
					// "transactionNature":0,
					"local":true,
					"central":true,
					"importExport":false,
					"localTransactionAccountId":null,
					"localTransactionAccountName":null,
					"centralTransactionAccountId":null,
					"centralTransactionAccountName":null,
					"importExportTransactionAccountId":null,
					"importExportTransactionAccountName":null,
					"additionalData":null,
					"numberSeriesId":null,
					"numberSeriesName":null,
					"printTemplateId":null,
					"printTemplateName":null,
					"transactionTypePrints":[],
					"isAllPartySelected":false,
					"transactionTypeFields":[],
					"transactionSections":[],
					"transactionTypeAddOns":[],
					"transactionParties":[],
					"taxMode":null,
					"paymentMode":null,
					"salesGroupType":null,
					"isRouteApplicable":null,
					"inventory":null,
					"invoiceType":1,
					"fieldItems":[],
					"activeSectionIndex":null,
					"activeFieldIndex":null,
					"addOnsProp":{},
					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},
					"addOnsProductLevel":[],
					"addOnsBillLevel":[],
					"tradingType":0
				},

				testItems:[{id:1, name:'abc'}, {id:1, name:'abc'}, {id:1, name:'abc'}],

				currentAddOnsIndex:null,

				toolBarTitle:null,

				tagId:null,

				formId:null,
				dialogStorageId:null,
				draftStorageId:null,

				backButtonPress:false,

				snackbar:false,
				snackbar_msg:null,

				unwatch:false,

				showImportExport:false,
				showInvoiceGroup:false,
				showInventory:false,
				showInvoiceType:false,

				titleFieldChanged: false,

				typeId:null,
				// typeName:null,

				invalidForm:false,
				fieldItemsComponentKey:null,
				fieldLIstDialogKey:this.guidWeb(),

				labels:{},
				invalidRoute:true,

				sectionItemList:[],

				addOnsLevelType:null,
				addOnsMovableItems:null,

				isLoading:false
			}
		},
		components:{
			'dialog-section-form': sectionForm,
			'dialog-field-list': fieldList,
			'dialog-section-list': sectionList,
			'field-form': fieldForm,
			'field-items': fields,
			'dialog-move-field': moveFieldDialog,
			'dialog-reorder-section': reorderSectionDialog,
			'dialog-number-series': numberSeriesDialog,
			'dialog-print-template':printTemplateDialog,
			'dialog-addons':dialogAddOns,
			'dialog-move-addons':dialogMoveAddOns,
			'dialog-loading':dialogLoading,
			'dialog-discard': dialogDiscard
		},
		watch:{
			'Form': {
                handler: function (newVal, oldVal){
                    // this.fn_saveToLocalStorage(this);
                    if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                },
                deep: true
            }
		},
		methods:{

			fn_updateType: function(action){
				if(action=='disableIE'){
					this.Form.importExport = false;
				}
				else{
					this.Form.local = false;
					this.Form.central = false;
					this.Form.taxMode == 0 ? this.Form.taxMode = 1 : '';
				}
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			// fn_updateInvoiceType: function(val){
			// 	if(val == 0){
			// 		this.Form.invoiceType = 0;
			// 		this.showInvoiceType = false;	
			// 	}
			// 	else{
			// 		this.showInvoiceType = true;
			// 	}

			// },

			comingSoon(){
				// this.snackbar = true;
				// this.snackbar_msg = "Coming Soon...";
				this.showToast("Coming Soon...");
			},

			fn_getFormData: function () {
				return this.Form;
			},

			fn_getTitle: function () {
				for(let i=0;i<transactionForms.length;i++){
					if(transactionForms[i].id == this.$route.params.typeId){
						this.toolBarTitle = transactionForms[i].title;
						this.invalidRoute = false;
						break;
					}
				}
			},

			fn_copyName: function (value) {
				console.log(this);
				if(!value && !this.Form.title){
					this.titleFieldChanged = false;	
				}

				if(!this.titleFieldChanged){
					this.Form.title = value;
				}
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				//only for when android dialog calls from web dialog;
				if(ref.indexOf('dialog') != -1){
					let key = ref.substring(0, ref.lastIndexOf('_'));
					let dialogRef = this.$refs[key];
		
					var checkRefs = setInterval(function(){
			          if(dialogRef.$refs.hasOwnProperty(ref)){
			          	clearInterval(checkRefs);
			          	dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			          }
			        },50);

					// dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
				else if(this.$refs.hasOwnProperty(ref)){
					this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
				else{
					this.$refs['ref_fieldsForm'].fn_onChange(tagId, ref, selectedValueId, selectedValueName, isRemoved);
				}
			},

			fn_onChangeMultiple: function(tagId, ref, selectedItemsId){
				this.$refs[ref].$attrs.onUpdate(selectedItemsId);
			},

			fn_openLocalTransactionLedgers: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;
				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newLedger"}];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.localTransactionAccountId && this.Form.localTransactionAccountName){
					paramObject.defaultValue = {"id":this.Form.localTransactionAccountId, "name":this.Form.localTransactionAccountName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_openCentralTransactionLedgers: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;
				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newLedger"}];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.centralTransactionAccountId && this.Form.centralTransactionAccountName){
					paramObject.defaultValue = {"id":this.Form.centralTransactionAccountId, "name":this.Form.centralTransactionAccountName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_openImportExportTransactionLedgers: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;
				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Ledger";
				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newLedger"}];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.importExportTransactionAccountId && this.Form.importExportTransactionAccountName){
					paramObject.defaultValue = {"id":this.Form.importExportTransactionAccountId, "name":this.Form.importExportTransactionAccountName};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_openPartyGroups: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;
				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Group";
				//static as action is different
				viewDialogObject.TopMenu = [{"MenuID":1, "MenuType":null, "Icon":null, "Text":"New", "Action":"newPartyGroup"}];

				viewDialogObject.isMultiple = true;
				viewDialogObject.isBottomMenu = false;

				if(this.typeName == 'sale')
					// viewDialogObject.accountGroupIds = [accountGroupIds.debtors.id, accountGroupIds.brandAndDivision.id];
					viewDialogObject.accountGroups = [accountGroupIds.debtors.id, accountGroupIds.brandAndDivision.id];
				else if(this.typeName == 'purchase')
					// viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id, accountGroupIds.brandAndDivision.id];
					viewDialogObject.accountGroups = [accountGroupIds.creditors.id, accountGroupIds.brandAndDivision.id];

				viewDialogObject.accountGroupStatus = 1;

				var paramObject = {};
				// paramObject.defaultValue = {"id":null, "name":null};
				let selectedLedgers = [];

				this.Form.transactionParties.forEach(item => {
					selectedLedgers.push(item.accountGroupId);
				})

				// this.Form.customerSupplierGroupData.selectedItems.forEach(item => {
				// 	selectedLedgers.push(item.id);
				// })
				
				paramObject.defaultValue = selectedLedgers;
				// paramObject.allSelected = this.Form.customerSupplierGroupData.allSelected;
				paramObject.allSelected = this.Form.isAllPartySelected;

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accountgroups', tagId, paramObject, ref);
			},

			fn_openAddOns: function (addOnsType, type, isNew) {

				if(addOnsType == 1){
					this.Form.addOnsProp.value = "discounts";
					this.Form.addOnsProp.toolbarTitle = "Discounts & Offers";
				}
				else if(addOnsType == 2){
					this.Form.addOnsProp.value = "taxes";	
					this.Form.addOnsProp.toolbarTitle = "Taxes";
				}
				else{
					this.Form.addOnsProp.value = "otherCharges";
					this.Form.addOnsProp.toolbarTitle = "Other Charges";
				}
				this.fn_openDialogWeb('web', 'AddOnsForm', 'ref_dialogAddOns');	

				if(isNew){
					this.Form.addOnsDataModel = {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":addOnsType, "type":type};

					this.fn_openAddOnsList('android', 'AddOns', 'ref_dialogAddOns_name', this.Form.addOnsDataModel.addOnsId, this.Form.addOnsDataModel.name);
				}
				
			},

			fn_openAddOnsList: function (platform, name, ref, itemId, itemName) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = this.Form.addOnsProp.toolbarTitle;
				// viewDialogObject.TopMenu = [menuItem.new];
				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":this.Form.addOnsProp.value};
				viewDialogObject.TopMenu = [menuItemCustom];
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.hideChip = true;
				viewDialogObject.hideAddOns = true;

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, this.Form.addOnsProp.value, tagId, paramObject, ref);
			},

			fn_saveAddOns: function (data) {
				let itemIndex = null;

				let transactionAddOnsData = null;

				if(data.type==0){
					transactionAddOnsData = this.Form.addOnsProductLevel;
				}
				else{
					transactionAddOnsData = this.Form.addOnsBillLevel;	
				}

				if(!data.transactionTypeAddOnsId){
					let itemExist = false;

					for(let i=0;i<transactionAddOnsData.length;i++){
						if(transactionAddOnsData[i].addOnsId == data.addOnsId && transactionAddOnsData[i].type == data.type){
							itemExist = true;
							itemIndex = i;
							break;
						}
					}

					if(itemExist){
						data.transactionTypeAddOnsId = transactionAddOnsData[itemIndex].transactionTypeAddOnsId;
						data.orderNumber = transactionAddOnsData[itemIndex].orderNumber;
						// transactionAddOnsData[itemIndex] = JSON.parse(JSON.stringify(data));
						// this.$forceUpdate();
						transactionAddOnsData.splice(itemIndex, 1, data);
						// return
					}
					else{
						data.transactionTypeAddOnsId = this.guid();
						data.orderNumber = transactionAddOnsData.length+1;
						transactionAddOnsData.push(data);
						// itemIndex = this.Form.transactionTypeAddOns.length-1;
					}
				}
				else{
					itemIndex = transactionAddOnsData.findIndex(item=>{
						return item.transactionTypeAddOnsId == data.transactionTypeAddOnsId;
					})
					transactionAddOnsData.splice(itemIndex, 1, data);
				}

				console.log(JSON.stringify(transactionAddOnsData));

				let self = this;
				setTimeout(function () {
					self.$vuetify.goTo('#item_'+data.transactionTypeAddOnsId, self.scrollOptions);
				},100);

				this.fn_closeDialog();
			},

			fn_editAddOns: function (item) {
				this.Form.addOnsDataModel = JSON.parse(JSON.stringify(item));
				this.fn_openAddOns(item.addOnsType, item.type);
			},

			fn_removeAddOns: function (item, index) {
				if(item.type==0)
					this.Form.addOnsProductLevel.splice(index, 1);
				else
					this.Form.addOnsBillLevel.splice(index, 1);
			},

			// fn_removeAddOns: function (t_addOnsId, index) {
			// 	if(this.Form.transactionTypeFormId){
			// 		let obj={};
			// 		obj.transactionTypeAddOnsId = t_addOnsId;
			// 		this.Form.deletedAddOnsIds.push(obj);
			// 	}
			// 	this.Form.transactionTypeAddOns.splice(index, 1);
			// },

			fn_openMoveAddOnsDialog: function (items, index) {
				this.addOnsMovableItems = JSON.parse(JSON.stringify(items));
				this.currentAddOnsIndex = index;
				this.fn_openDialogWeb('web', 'MoveAddOns', 'ref_dialogMoveAddOns');
			},

			fn_moveAddOns: function (type, index) {
				this.fn_closeDialog();
				let transactionAddOnsData = null;
				if(type==0){
					transactionAddOnsData = this.Form.addOnsProductLevel;
				}
				else{
					transactionAddOnsData = this.Form.addOnsBillLevel;	
				}
				let addOnsItem = JSON.parse(JSON.stringify(transactionAddOnsData[this.currentAddOnsIndex]));
				transactionAddOnsData.splice(this.currentAddOnsIndex, 1);

				let itemIndex = index;
				this.currentAddOnsIndex > index ? itemIndex = itemIndex+1 : '';
				transactionAddOnsData.splice(itemIndex, 0, addOnsItem);
			},

			fn_updateLocalTransactionLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.localTransactionAccountId = selectedValueId;
		        	this.Form.localTransactionAccountName = selectedValueName;
		        	this.$forceUpdate();
		        	this.errors.remove('local ledger');
				}
				else{
					this.Form.localTransactionAccountId = null;
		        	this.Form.localTransactionAccountName = null;
				}
				//force save to local storage
				this.fn_saveDraft(this.Form.name);
			},

			fn_updateCentralTransactionLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.centralTransactionAccountId = selectedValueId;
		        	this.Form.centralTransactionAccountName = selectedValueName;
		        	this.$forceUpdate();
		        	this.errors.remove('central ledger');
				}
				else{
					this.Form.centralTransactionAccountId = null;
		        	this.Form.centralTransactionAccountName = null;
				}
				//force save to local storage
				this.fn_saveDraft(this.Form.name);
			},

			fn_updateImportExportTransactionLedger: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.importExportTransactionAccountId = selectedValueId;
		        	this.Form.importExportTransactionAccountName = selectedValueName;
		        	this.$forceUpdate();
		        	this.errors.remove('salepurchase ledger');
				}
				else{
					this.Form.importExportTransactionAccountId = null;
		        	this.Form.importExportTransactionAccountName = null;
				}
				//force save to local storage
				this.fn_saveDraft(this.Form.name);
			},

			fn_updatePartyGroups: function (selectedItemsId) {
				let self = this;
				this.getSelectedItems(selectedItemsId, 
					{
						onSuccess: function(response){
				          console.log(response);
				          // self.Form.customerSupplierGroupData = JSON.parse(response);
				          let data = JSON.parse(response);
				          self.Form.isAllPartySelected = data.allSelected;

				          self.Form.transactionParties = [];

				          if(!self.Form.isAllPartySelected){

				          	data.selectedItems.forEach(function (item) {
				          		let obj = {};
					          	obj.transactionTypePartyId = self.guid();
					          	obj.accountGroupId = item.id;
					          	obj.name = item.name;
					          	self.Form.transactionParties.push(obj);	
				          	});

				          }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
				);
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				// dialogjs.fn_fixBackgroundScroll();
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_resetFieldData: function () {
				this.Form.fieldData = JSON.parse(JSON.stringify(require('../../fields/datamodel.js').data.fieldData));
			},

			fn_removePartyGroup: function (index) {
				this.Form.transactionParties.splice(index, 1)
			},

			// fn_removePartyGroup: function (t_partyId, doNotRemoveParty) {
			// 	if(this.Form.transactionTypeFormId){
			// 		let obj={};
			// 		obj.transactionTypePartyId = t_partyId;
			// 		this.Form.deletedPartyIds.push(obj);
			// 	}

			// 	let itemIndex = this.Form.transactionParties.findIndex(item=>{
			// 		return item.transactionTypePartyId == t_partyId;
			// 	})

			// 	!doNotRemoveParty ? this.Form.transactionParties.splice(itemIndex, 1) : '';
			// },

			fn_removeAllPartyGroups: function () {
				this.Form.isAllPartySelected = false;
			},

			fn_openNumberSeriesDialog: function () {
				this.fn_openDialogWeb('web', 'NumberSeries', 'ref_numberSeries');
			},

			fn_openPrintTemplateDialog: function () {
				this.fn_openDialogWeb('web', 'PrintTemplate', 'ref_printTemplate');
			},

			fn_setNumberSeries: function (item, preventCloseDialog) {
				console.log(item);
				this.Form.numberSeriesId = item.numberSeriesId;
				this.Form.numberSeriesName = item.name;
				this.errors.remove('Number Series');
				!preventCloseDialog ? this.fn_closeDialog() : '';
			},

			fn_setPrintTemplate: function (item, preventCloseDialog) {
				console.log(item);
				this.Form.printTemplateId = item.printTemplateId;
				this.Form.printTemplateName = item.name;
				this.errors.remove('print_template');
				!preventCloseDialog ? this.fn_closeDialog() : '';
			},

			fn_removePrintTemplate: function(){
				this.Form.printTemplateId = null;
				this.Form.printTemplateName = null;
				this.Form.transactionTypePrints = [];
				this.fn_closeDialog();
			},

			fn_getBottomMenu: function (level) {
				// let bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.help]};;
				let bottomMenu = null;
				if(level){
					level=='product' ? this.addOnsLevelType = 0 : this.addOnsLevelType = 1;
					bottomMenu = {"BottomMenu": [menuItem.addDiscount, menuItem.addTaxes, menuItem.addOtherCharges]};
				}

				let tagId = null;
				this.setBottomMenu(tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_closeDialog: function (tagId) {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},
			
			fn_checkValidations: function(){

				var self = this;
			    this.$validator.validateAll().then((result) => {
			        if (result) {
			        	// if(!self.Form.customerSupplierGroupData.selectedItems.length){
			        	if(!this.Form.local && !this.Form.central && !this.Form.importExport){
			        		self.invalidForm = true;
			        		self.$vuetify.goTo('#transactionType_field', self.scrollOptions);
			        		return;
			        	}

			        	if((this.typeName=='purchase' || this.typeName=='sale') && !self.Form.isAllPartySelected && !self.Form.transactionParties.length){
			        		// self.snackbar = true;
			        		// self.snackbar_msg = "You have to choose minimum one "+this.labels.partyGroup.toLowerCase();
			        		self.showToast("You have to choose minimum one "+this.labels.partyGroup.toLowerCase());
			        		self.invalidForm = true;
			        		self.$vuetify.goTo('#partyGroups_field', self.scrollOptions);
			        		return;
			        	}

			           	self.fn_post();
			          	return; 
			        }
			        else{
			        	self.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},
			
			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('TransactionTypeForm', dataObj, 
					{
						onSuccess: function(response){
				          console.log(response);
				          let status = JSON.parse(response);
				          if(status) {
				          	self.fn_cleanUp();
				          }
				          else {
				          	// self.snackbar = true;
				          	// self.snackbar_msg = "Already exists with this name";
				          	self.showToast("Already exists with this name");
				          }
				          // self.fn_cleanUp();
				        },
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_cleanUp: function () {

				if(this.$route.query.ls){
					let data = {};
					data.type = 'transactionTypeForm';
					data.id = this.Form.transactionTypeFormId;
					data.name = this.Form.name;
					localStorage.setItem('newItem', JSON.stringify(data));
					localStorage.setItem('closeDialog', 1);
				}

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					self.$router.go(-1);
				});
			},
			
			fn_post: function(){

				this.Form.name = this.Form.name.trim();

				!this.Form.transactionTypeFormId ? this.Form.transactionTypeFormId = this.guid() : '';

				this.Form.transactionTypeId = this.typeId;

				if(this.Form.importExport){
					this.Form.localTransactionAccountId = null;
					this.Form.centralTransactionAccountId = null;
				}
				else{
					!this.Form.local ? this.Form.localTransactionAccountId = null : '';
					!this.Form.central ? this.Form.centralTransactionAccountId = null : '';
					this.Form.importExportTransactionAccountId = null;
				}

				let self = this;
				if(this.Form.isAllPartySelected){
					this.Form.transactionParties = [];
				}
				else{
					for(let i=0; i<this.Form.transactionParties.length; i++){
						this.Form.transactionParties[i].transactionTypePartyId = this.guid();
						this.Form.transactionParties[i].transactionTypeFormId = self.Form.transactionTypeFormId;
					}
				}

				this.Form.transactionTypePrints = [];
				if(this.Form.printTemplateId){
					let obj = {};
					obj.transactionTypePrintId = this.guid();
					obj.printTemplateId = this.Form.printTemplateId;
					obj.orderNumber = 1;
					this.Form.transactionTypePrints.push(obj);
				}

				this.Form.transactionTypeAddOns = [];

				this.Form.addOnsProductLevel.forEach(function (item) {
					self.Form.transactionTypeAddOns.push(item);
				});

				this.Form.addOnsBillLevel.forEach(function (item) {
					self.Form.transactionTypeAddOns.push(item);
				})

				this.Form.transactionSections = [];
				this.Form.transactionTypeFields = [];
				
				for(let i=0; i<this.Form.fieldItems.length; i++){
					let sectionObj = {};

					//generating new section id if copy
					this.$route.query.copy ? this.Form.fieldItems[i].section.sectionId = this.guid() : '';

					sectionObj.sectionId = this.Form.fieldItems[i].section.sectionId;
					sectionObj.sectionName = this.Form.fieldItems[i].section.sectionName;
					sectionObj.orderNumber = i+1;
					sectionObj.isHidden = this.Form.fieldItems[i].section.isHidden;

					this.Form.transactionSections.push(sectionObj);

					for(let j=0; j<this.Form.fieldItems[i].fields.length; j++){
						let fieldObj = {};

						//generating new field id if copy
						this.$route.query.copy ? this.Form.fieldItems[i].fields[j].transactionTypeFieldId = this.guid() : '';

						fieldObj.transactionTypeFieldId = this.Form.fieldItems[i].fields[j].transactionTypeFieldId;
						fieldObj.fieldId = this.Form.fieldItems[i].fields[j].fieldId;
						fieldObj.displayName = this.Form.fieldItems[i].fields[j].displayName;
						fieldObj.isRequired = this.Form.fieldItems[i].fields[j].isRequired;
						fieldObj.isHidden = this.Form.fieldItems[i].fields[j].isHidden;
						fieldObj.additionalData = null;
						fieldObj.transactionTypeId = this.typeId;
						fieldObj.sectionId = this.Form.fieldItems[i].section.sectionId;
						this.Form.transactionTypeFields.push(fieldObj);
					}
				}

				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			// fn_get: function(itemId, copyData){
			// 	var self = this;

			// 	this.getData('TransactionTypeForm', itemId, 
			// 		{
			// 			onSuccess: function(response){
			// 	          console.log(response);
			// 	          let data = JSON.parse(response);
			// 	          self.fn_bindData(data, copyData);
			// 	        }, 
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	          self.hideLoading();
			// 	        }
			// 		}
		 //        );
			// },

			fn_get: function(itemId, copyData){
				var self = this;
				let filterObject = {};
				//sending current fiscalYear
				filterObject.fiscalYear = JSON.stringify(this.fn_getFiscalYear());
				this.getFilterData('TransactionTypeForm', itemId, filterObject,
					{
						onSuccess: function(response){
				          console.log(response);
				          let data = JSON.parse(response);
				          self.fn_bindData(data, copyData);
				        }, 
				        onError: function(error){
				          console.log(error);
				          self.hideLoading();
				        }
					}
		        );
			},

			fn_getFiscalYear: function(date){
	            let dateObj = date ? new Date(date) : new Date();
	            let month = dateObj.getMonth() + 1;
	            let year = dateObj.getFullYear();
	            let fy = month > 3 ? year : year-1;
	            return fy
	        },

			fn_bindData: function (data, copyData) {
				let self = this;

				this.Form.additionalData = data.additionalData;
				this.Form.centralTransactionAccountId = data.centralTransactionAccountId;
				this.Form.centralTransactionAccountName = data.centralTransactionAccountName;
				this.Form.importExportTransactionAccountId = data.importExportTransactionAccountId;
				this.Form.importExportTransactionAccountName = data.importExportTransactionAccountName;
				this.Form.isAllPartySelected = data.isAllPartySelected;
				this.Form.localTransactionAccountId = data.localTransactionAccountId;
				this.Form.localTransactionAccountName = data.localTransactionAccountName;
				this.Form.name = data.name;
				this.Form.numberSeriesId = data.numberSeries.numberSeriesId;
				this.Form.numberSeriesName = data.numberSeries.name;

				// if(data.printTemplateId){
				// 	this.Form.printTemplateId = data.printTemplateId;
				// 	this.Form.printTemplateName = data.printTemplateName;
				// }

				if(data.transactionTypePrints && data.transactionTypePrints.length){
					this.Form.printTemplateId = data.transactionTypePrints[0].printTemplateId;
					this.Form.printTemplateName = data.transactionTypePrints[0].printTemplateName;
				}

				this.Form.title = data.title;
				this.Form.local = data.local;
				this.Form.central = data.central;
				this.Form.importExport = data.importExport;
				this.Form.tradingType = data.tradingType;

				this.Form.transactionParties = JSON.parse(JSON.stringify(data.transactionParties));
				this.Form.transactionSections = JSON.parse(JSON.stringify(data.transactionSections));

				this.Form.addOnsProductLevel = [];
				this.Form.addOnsBillLevel = [];

				data.transactionTypeAddOns.forEach(function (item) {

					//generating new transactionTypeAddOnsId if copy data
					copyData ? item.transactionTypeAddOnsId = self.guid() : '';

					item.type == 0 ? self.Form.addOnsProductLevel.push(item) : self.Form.addOnsBillLevel.push(item);
				})


				this.Form.transactionTypeFields = JSON.parse(JSON.stringify(data.transactionTypeFields));
				this.Form.transactionTypeFormId = data.transactionTypeFormId;
				this.Form.transactionTypeId = data.transactionTypeId;

				if(this.typeName=='sale' && !this.invalidRoute){
					this.Form.taxMode = data.taxMode;
					this.Form.paymentMode = data.paymentMode;
					this.Form.salesGroupType = data.salesGroupType;
					this.Form.isRouteApplicable = data.isRouteApplicable;
				}

				this.Form.invoiceType = data.invoiceType;

				//incase of expense
				this.Form.inventory = data.inventory;

				//binding section and fields

				this.Form.fieldItems = [];
				for(let i=0; i<this.Form.transactionSections.length; i++){

					let obj = {};
					obj.section = JSON.parse(JSON.stringify(this.Form.transactionSections[i]));
					obj.fields = [];

					for(let j=0; j<this.Form.transactionTypeFields.length; j++){
						if(this.Form.transactionSections[i].sectionId == this.Form.transactionTypeFields[j].sectionId){
							obj.fields.push(this.Form.transactionTypeFields[j]);
						}
					}

					this.Form.fieldItems.push(obj);
				}

				if(copyData){
		          	this.Form.transactionTypeFormId = null;
					this.showToast("Transaction Form copied");
		        }

		        self.hideLoading();

			},

			fn_getLedgerName: function (ledgerId, callback) {
			  	this.getData('Ledger', ledgerId, 
					{
						onSuccess: function(response){
				          let ledgerData = JSON.parse(response);
				          if(ledgerData && ledgerData.name){
				          	callback(ledgerData.name);
				          }
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},
			
			fn_clearForm: function(){
				this.fn_resetFieldData();
				this.Form = {
					"name":null,
					"title":null,
					"transactionTypeId":null,
					// "transactionNature":0,
					"local":true,
					"central":true,
					"importExport":false,

					"localTransactionAccountId":null,
					"localTransactionAccountName":null,
					"centralTransactionAccountId":null,
					"centralTransactionAccountName":null,
					"importExportTransactionAccountId":null,
					"importExportTransactionAccountName":null,
					"additionalData":null,
					"numberSeriesId":null,
					"numberSeriesName":null,
					"printTemplateId":null,
					"printTemplateName":null,
					"isAllPartySelected":false,
					"transactionTypeFields":[],
					"transactionSections":[],
					"transactionTypeAddOns":[],
					"transactionParties":[],
					"taxMode":null,
					"paymentMode":null,
					"salesGroupType":null,
					"isRouteApplicable":null,
					"inventory":null,
					"invoiceType":1,
					"fieldItems":[],
					"activeSectionIndex":null,
					"activeFieldIndex":null,
					"addOnsProp":{},
					"addOnsDataModel": {"transactionTypeAddOnsId":null, "addOnsId":null, "name":null, "percentage":null, "value":null, "mode":null, "nature":null, "appliedOn":0, "adjustInTotal":true, "orderNumber":null, "addOnsType":null, "type":null},
					"addOnsProductLevel":[],
					"addOnsBillLevel":[],
					"tradingType":0
				}
				this.fn_initializeSettings();
			},

			// fn_saveToLocalStorage: function(){
			// 	if(!this.unwatch){
			// 		var dataObj = {};
			// 		dataObj.type = "TransactionType";
			// 		dataObj.formType = "new";
			// 		dataObj.modifiedDate = new Date();
			// 		dataObj.formId = this.formId;
			// 		dataObj.draftId = this.draftStorageId;
			// 		dataObj.uri = this.$route.path;
			// 		dataObj.dataModel = this.Form;

			// 		localStorage.setItem(this.draftStorageId, JSON.stringify(dataObj));
			// 	}
			// 	this.unwatch = false;
			// },
			
			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;

				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='newLedger'){
					this.$router.push({path:'/masters/accounts/ledgers/items/new', query:{tagId:this.guidWeb()}});
				}
				else if(menuAction=='newPartyGroup'){
					this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb()}});
				}
				else if(menuAction=='discounts'){
					this.$router.push({path:'/addons/discounts/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='taxes'){
					this.$router.push({path:'/addons/taxes/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='otherCharges'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='adddiscount' || menuAction=='addtaxes' || menuAction=='addothercharges'){
					let addOnsType = menuAction=='adddiscount' ? 1 : menuAction=='addtaxes' ? 2 : 3;
					this.fn_openAddOns(addOnsType, this.addOnsLevelType, true);
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;

				if(this.Form.transactionTypeFormId){
					this.fn_get(this.Form.transactionTypeFormId);
				}
				else{
					this.fn_clearForm();
				}

				// if(localStorage.getItem(this.draftStorageId)){
				// 	localStorage.removeItem(this.draftStorageId);
				// }
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log('draft deleted');
				});
			},
			
			fn_showWebView: function () {
				var viewObject = {};

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "numberSeries":
					    	this.fn_setNumberSeries({numberSeriesId:itemData.id, name:itemData.name}, true);
					        break;
					    case "printTemplate":
					    	this.fn_setPrintTemplate({printTemplateId:itemData.id, name:itemData.name}, true);
					        break;
					    case "discounts":
					    case "taxes":
					    case "otherCharges":
					    	this.$refs['ref_dialogAddOns'].fn_updateAddOns(itemData.id, itemData.name, false);
					        break;
					    case "field":
					    	this.$refs['ref_fieldsForm'].fn_setFieldValue(itemData);
					        break;

					        
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}
			},
			
			fn_goBack: function(){
				this.backButtonPress = true;
				this.$router.go(-1);
			},

			fn_initializeSettings: function () {
				this.typeId = Number(this.$route.params.typeId);
				// this.typeName = this.$route.params.typeName.toLowerCase();

				this.fn_getTitle();

				if(this.typeName=='purchase'){
					//assigning lables
					this.labels.localLedger = 'Local Purchase Legder';
					this.labels.centralLedger = 'Central Purchase Legder';
					this.labels.importExportLedger = 'Purchase Ledger';
					this.labels.importExport = 'Import';
					this.labels.partyGroup = 'Supplier';

					if(this.typeId ==  transactionTypes.purchaseInvoice.id || this.typeId ==  transactionTypes.purchaseReturn.id){
						this.showImportExport = true;
					}

					if(this.typeId ==  transactionTypes.expense.id){
						this.showInventory = true;
						// this.showInvoiceType = true;
						this.Form.inventory = 1;
					}
				}
				else if(this.typeName=='sale'){
					//assigning lables
					this.labels.localLedger = 'Local Sales Legder';
					this.labels.centralLedger = 'Central Sales Legder';
					this.labels.importExportLedger = 'Sales Ledger';
					this.labels.importExport = 'Export';
					this.labels.partyGroup = 'Customer';

					this.Form.taxMode = 0;
					// this.Form.paymentMode = 0;
					// this.Form.salesGroupType = 0;
					this.Form.isRouteApplicable = true;
					// this.Form.numberSeries = {"numberSeriesId":null, "name":null, "prefix":null, "suffix":null, "nextNumber":null};

					if(this.typeId ==  transactionTypes.salesInvoice.id || this.typeId ==  transactionTypes.salesReturn.id){
						this.showImportExport = true;
						this.Form.paymentMode = 0;
					}

					if(this.typeId ==  transactionTypes.salesInvoice.id){
						// this.showInvoiceGroup = true;
						this.showInvoiceType = true;
						this.Form.salesGroupType = 1;
					}
				}
			}
		},
		mounted: function(){

			this.fn_initializeSettings();

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'cache_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			var formsArray = [];
			if(localStorage.getItem('transTypeForms')){
				formsArray = JSON.parse(localStorage.getItem('transTypeForms'));
			}

			formsArray.push(this.formId);
			localStorage.setItem('transTypeForms', JSON.stringify(formsArray));


			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;

			
			this.fn_showWebView();


			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				var self = this;
				// this.fn_setFormDataFromLocalStorage();
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);	
					}
					// self.Form.inventory == 0 ? self.showInvoiceType = false : '';
		            
				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			this.fn_setDraftData('temp', this.toolBarTitle);
		},
		computed:{
			typeName: function () {

				let typeName = null;

				switch (this.typeId) {
				    case transactionTypes.order.id:
				    case transactionTypes.deliveryChallan.id:
				    case transactionTypes.salesInvoice.id:
				    case transactionTypes.salesReturn.id:
				    case transactionTypes.estimate.id:
				        typeName = "sale";
				        break;
				    case transactionTypes.purchaseOrder.id:
				    case transactionTypes.purchaseChallan.id:
				    case transactionTypes.purchaseInvoice.id:
				    case transactionTypes.purchaseReturn.id:
				    case transactionTypes.expense.id:
				        typeName = "purchase";
				        break;
				    case transactionTypes.stockJournal.id:
				        typeName = "stockjournal";
				        break;
				    default:
				    	typeName = null;
				}

				console.log(typeName);

				return typeName;
			}
		},
		beforeRouteEnter (to, from, next) {
		  	next(vm => {

		  		if(localStorage.getItem('closeDialog')){
					vm.fn_closeDialog();
					localStorage.removeItem('closeDialog');
				}
				else{
					dialogjs.fn_checkAndShowOpenDialogs(vm);
				}
		  		// dialogjs.fn_checkAndShowOpenDialogs(vm);

		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from list view
		  		if(from.name=='transactionTypeItems' && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'transactionTypeItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  				copyData = true;
		  			}
		  		}

		  		if(itemId){
		  			let self = vm;
		  			self.showLoading('Please wait...');
		  			setTimeout(function(){
		  				self.fn_get(itemId, copyData);
		  			},100);
		  		}

		  	})
		},

		beforeRouteUpdate (to, from, next) {

			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('transTypeForms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },

		beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					this.backButtonPress = false;
					next(false);
				}
				else{
					next(true);
				}
			}
			else{
				// this.backButtonPress ? localStorage.removeItem(this.draftStorageId) : '';
				// localStorage.removeItem('transTypeForms');
				// next();
				if(this.askToDiscard){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					localStorage.removeItem('transTypeForms')
					next();	
				}
			}
	    }

	}

</script>

<style>
.list-item {
  // display: inline-block;
  margin-right: 10px;
}
.list-enter-active, .list-leave-active {
  transition: all .5s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
</style>


// WEBPACK FOOTER //
// src/components/settings/transaction/transaction_type_form.vue